import React from 'react';

export function getActionsArray(children: React.ReactNode) {
  return React.Children.toArray(children)
    .filter(item => React.isValidElement(item))
    .map(({ props }: any, i) => ({
      id: `action_${i}`,
      ...props,
    }));
}
